import { useEffect, useRef } from 'react';
import { render } from 'react-dom';

import './style.scss';
import Style from './Style';

// Button
document.addEventListener('DOMContentLoaded', () => {
	const allButtons = document.querySelectorAll('.wp-block-btn-button');
	allButtons.forEach(button => {
		const attributes = JSON.parse(button.dataset.attributes);

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<RenderButton attributes={attributes} />
		</>, button);

		button?.removeAttribute('data-attributes');
	});
});

const RenderButton = ({ attributes }) => {
	const { text, url, target, tooltip, isDownload, isUpIcon, icon, upIcon, animationType, animationDuration } = attributes;

	const buttonEl = useRef(null);

	useEffect(() => {
		isDownload ? buttonEl?.current?.setAttribute('download', '') : buttonEl?.current?.removeAttribute('download');

		AOS.init();
	}, []);

	return <a
		className='btnButton'
		data-aos={animationType}
		// data-aos-offset={100}
		// data-aos-delay={50}
		data-aos-duration={animationDuration * 1000}
		// data-aos-easing='ease-in-out'
		// data-aos-mirror='false'
		// data-aos-once='false'
		// data-aos-anchor-placement='bottom-bottom'
		href={url}
		target={target}
		rel='noopener noreferrer'
		tooltip={tooltip}
		position='top'
		ref={buttonEl}
	>
		{isUpIcon && upIcon?.url && <img src={upIcon?.url} alt={upIcon?.alt} />}

		{!isUpIcon && icon?.class && <i className={icon?.class}></i>}

		<span className='btnText' dangerouslySetInnerHTML={{ __html: text }} />
	</a>
}